export default "__VITE_ASSET__BkyTh$Ax__"